const PanelCode = Object.freeze({
  // BASELINE: '4325',
  // FOLLOWUP: '5325', 
  // BASIC: 'Basic',
  CUSTOM: 0,
  ADVANCED_BASELINE: 1,
  ADVANCED_FOLLOWUP: 2,
  ATHLETE: 3,
  TESTOSTERONE: 4,
  BIOMETRICS: 5,
  ALLERGY: 6,
  THYROID: 7,
  GALLERI: 8,
  CHOLESTEROL_THERAPY: 9,
  HEART_HEALTH: 10,
  CHOLESTEROL_BALANCE: 11,
  FERTILITY: 12,
  OMEGA_3_INDEX: 13,
  NMR_LIPOPROFILE: 14,  
  DEXA_BODYCOMP: 15,
  CAC: 16,
  SLEEP: 17,
  VO2MAX: 18,
  PERFORMANCE: 19,
  CCTA: 20,
  MYCOTOX: 21,
  FIT_STOOL: 22,
  ECG: 23,
  STRESS_TEST: 24,
  CMP: 25,
  LIPID: 26,
  ANEMIA: 27,
  CBC_DIFF: 28,
  DEXA_BONE: 29,
  SPERM: 30,
  URINALYSIS: 31,
  FATIGUE: 32,
  CELIAC: 33,
  BLOOD_TYPE: 34,
  HEAVY_METALS: 35,
  LYME_AB_SCREEN: 36,
  HEPATIC: 37,
  INSULIN_RESISTANCE: 38,
  ATTIA: 39,
  THYROID_ANTIBODIES: 40,
  STEROLS: 41,
  ANA_SCREEN_REFLEX: 42, 
  AMYLASE_ISOENZYMES: 43,
  OMEGACHECK: 44,
  OMEGA_3_INDEX_COMPLETE: 45,
  GB_INSIGHTS_HH_GENETIC: 46,
  AMBRY_CANCER_GENETICS: 47,
  STEROIDS: 48,
  CBC: 49,
  PT_INR: 50,
  CARDIOIQ_IR_PANEL: 51,
  MMR_TITERS: 52,
  VITAMIN_E: 53,
  IRON: 54,
  CK_ISOENZYMES: 55,
  IRON_TIBC: 56,
  HDL_FUNCTION: 57,
  PSA: 58,
  HOMA_IR: 59,
  RENAL_FUNCTION: 60,
  INSTALAB_PANEL_FEMALE: 61,
  RF: 62,
  IGG_SUBCLASSES: 63,
  AFP_AFP_L3: 64,
  LDH_ISOENZYMES: 65,
  ESTROGEN_FRACTIONATED: 66,
  ALP_ISOENZYMES: 67, 
  EBV_ANTIBODIES: 68,
  RBC_ANTIBODY: 69,
  ANCA: 70,
  SJOGREN_ANTIBODIES: 71,
  CARDIOLIPIN_AB: 72,
  BETA_2_GLYCOPROTEIN_I_AB: 73,
  PROTEIN_ELECTRO: 74,
  NK_CELLS: 75,
  AMYLOID_BETA: 76, 
  FIBROTEST_ACTITEST: 77,
  ADMA_SMDA: 78,
  FOOD_ALLERGY: 79,
})

export default PanelCode